import permissions from 'constants/permissions'

const TAG_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.TAG.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.TAG.MANAGE,
  },
]

export default TAG_LIST
